"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function DuplicatedImageWithTextBlock() {
  const {
    ref: imageRef,
    isVisible: imageVisible
  } = useRevealOnScroll({
    threshold: 0.3,
    once: true
  });
  const {
    ref: contentRef,
    isVisible: contentVisible
  } = useRevealOnScroll({
    threshold: 0.3,
    once: true
  });
  return <section id="duplicatedimagewithtextblock" className="relative bg-background py-16 mt-[50px] !h-[900px] md:py-24">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="grid gap-12 items-center ![margin:-100px_0px_0px_0px] lg:grid-cols-2 lg:gap-16">
          {}
          <div ref={imageRef} className={`relative transition-all duration-700 ${imageVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-12"}`}>
            <div className="relative overflow-hidden rounded-lg shadow-medium">
              <img src="https://newmavericks.com/wp-content/uploads/2026/02/Paolo-pic-copy-scaled.jpg" alt="NewMavericks workspace collaboration" className="w-full h-auto object-cover !m-0" />
            </div>
          </div>

          {}
          <div ref={contentRef} className="relative transition-all duration-700 delay-200 opacity-100 translate-x-0 ![margin:50px_0px_0px_0px]">
            <div className="space-y-6">
              <h2 className="font-display font-bold text-foreground leading-tight !text-4xl !w-[600px] ![margin:0px_0px_24px_0px]">Paolo D'Angelo <br />CoFounder &amp; Executive Chairman</h2>
              
              

              <p className="text-base text-white leading-relaxed">Paolo is Co Author of <span className="font-bold"><Link to="https://www.amazon.com/Science-Protection-Impactful-Leadership-Decisions/dp/1735345849/ref=sr_1_1?crid=1MBHIA4MAPRJL&dib=eyJ2IjoiMSJ9.9qmsWu42wx8qiTQMRWB-B2ZIVHHAupxjvMBT1IyifIAz9b90o9mkuV5E6tYkBQE7DEMt9vUHGCZuMAJsYHf6BVhDMIV4gKk50likNP1_RuJ5UQoqSKrKBBJhLBlXs96Dv6yfO-4nQJUqtKun5O3IUhJlFxohML0fsD01zTs5wnRDrJLUzCvgEH4BXib167i8DN12GzjtzwHP7MKydEmJfN5hSwvjtM_yD-2Qhftw0g.QKkpudWpyoJ7YSAyBqrXZ1lUii-UalH6fQ8VYVNCQMA&dib_tag=se&keywords=raamon&qid=1771212226&sprefix=ramon%2Caps%2C854&sr=8-1" newTab>The Science of Protection</Link>: Making High Pressure Impactful Leadership Decisions that Protect You &amp; Everyone.</span><div><br /></div><div>He came from a background of being a competitive bodybuilder and personal trainer owning his own gym, security company, and sport &amp; entertainment ticket selling business.&nbsp;</div><div><br /></div><div>At the age of 25 he realized that true fulfillment really started on the inside.&nbsp;</div><div><br /></div><div>He then devoted himself to 15 years meditating full-time 8 hours per day, 7 days per week, with six of those years 7,000 feet up in the Himalayas, for his own personal development, enlightenment, and contribution to world peace.</div><div><br /></div><div>Since the age of 19 he’s been around wealthy influential business leaders who have seen him as a great trusted advisor because of his spontaneous timely street wise insights.&nbsp;</div><div><br /></div><div>For the last 25 years he's travelled extensively around the world supporting CEOs &amp; executives to have greater mental capacity, protection &amp; support to lead from a place of fulfillment &amp; peace rather than stress &amp; fear.&nbsp;</div><div><br /></div><div>His passionate purpose is to enable top leaders to be and stay in a peak state of leadership consciousness.&nbsp;</div><div><br /></div><div>He is a philanthropist for peace projects, nuns, volunteers to support women going through trauma and anchoring people in a peak state.</div><div><br /></div></p>

              <div className="flex flex-wrap gap-4 pt-4">
                <Link to="/ServicesPage">
                  
                </Link>

                <Link to="/ContactPage">
                  
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}